<div class="theme-static">
  <section class="header position-fixed w-100">
    <app-common-header></app-common-header>
  </section>

  <!-- End Header Part -->

  <!-- Start Page Header Title Part -->
  <section class="page-header-title">
    <div class="page-title-overlay"></div>
    <img src="{{ pageTitleImg }}" alt="" class="w-100 page-title-image" />
    <div class="page-header-title-caption">
      <h1>{{ pageHead }}</h1>
    </div>
  </section>
  <!-- End Page Ttile  -->

  <!-- Main Content -->
  <main class="page-content py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="page-content-info">
            <p class='text-dark'>
              <strong>This travel alert is no longer active and will not impact coverage for a new policy purchase.</strong> 
            </p>
            <p>
              <strong>Travel insurance information for Virgin Australia</strong>
            </p>
            <p>Virgin Australia announced the morning of 21 April 2020 it has entered voluntary administration.</p>
            <p>In a statement to the ASX, the airline said the move would help "recapitalise the business" and ensure it emerged "in a stronger financial position on the other side of the COVID-19 crisis".</p>
            <p>
              <a href="https://www.abc.net.au/news/2020-04-21/virgin-australia-goes-into-voluntary-administration-coronavirus/12167814" target="_blank">https://www.abc.net.au/news/2020-04-21/virgin-australia-goes-into-voluntary-administration-coronavirus/12167814</a>
            </p>
            <p>All claims relating to this event will be assessed based on your circumstances and in accordance with the Product Disclosure Statement (PDS) applicable to your policy level.</p>
            <p>
              <strong>If your policy was purchased before 9am (AEST) on 21 April 2020 –</strong>
            </p>
            <p>There may be coverage under Section 10 Financial Default, but this can only be determined once a formalised statement from the administrators has been issued. At this stage we are unaware how current bookings, refunds, or credits will be affected. As the situation continues to develop, we advise to await further information from the administrators on their formal position of the future of the airline.</p>
            <p>
              <strong>If you purchased your policy after 9am (AEST) on 21 April 2020 –</strong>
            </p>
            <p>Our policy does not provide cover for any event you were aware of before your policy cover commenced.  If you purchased your policy after 21 April 2020, we would expect this was done with knowledge of the current Virgin Australia event and therefore there would be no coverage for any claim which was a result of this event.</p>
            <p>We will continue to monitor the situation and advise accordingly.</p>
          </div>
        </div>
      </div>
    </div>
  </main>
  <!-- Footer Area -->
  <app-footer></app-footer>
</div>
